const AccountingIcon = () => {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_302)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M58.2967 34.6776C57.8936 34.6776 57.5639 35.0068 57.5639 35.4092V60.537H19.4583V32.7391H33.3815V40.7858C33.3815 41.1882 33.7112 41.5174 34.1143 41.5174H42.9079C43.3109 41.5174 43.6407 41.1882 43.6407 40.7858V32.7391H45.4873C45.8904 32.7391 46.2201 32.4099 46.2201 32.0076C46.2201 31.6052 45.8904 31.2761 45.4873 31.2761H43.5454L42.2923 22.4978H44.6373C45.0403 22.4978 45.3701 22.1686 45.3701 21.7663C45.3701 21.3639 45.0403 21.0347 44.6373 21.0347H23.1223C22.8292 21.0347 22.5653 21.2103 22.4481 21.481L18.0513 31.7223V31.7296C18.022 31.8101 18.0073 31.8905 18 31.9783C18 31.9856 18 32.0003 18 32.0076V61.2685C18 61.6708 18.3298 62 18.7328 62H58.304C58.707 62 59.0368 61.6708 59.0368 61.2685V35.4092C59.0368 35.0068 58.707 34.6776 58.304 34.6776H58.2967ZM34.8471 32.0588L36.2174 22.4978H40.8121L42.1824 32.0588V40.0543H34.8544V32.0588H34.8471ZM23.6059 22.4978H34.7372L33.4841 31.2761H19.8393L23.6059 22.4978Z'
            fill='#FEFEFE'
          />
          <path
            d='M52.4736 55.3077C52.8767 55.3077 53.2064 54.9785 53.2064 54.5761V50.4869L54.1518 51.4306C54.2983 51.5769 54.4815 51.6427 54.672 51.6427C54.8626 51.6427 55.0458 51.5696 55.1923 51.4306C55.4781 51.1453 55.4781 50.6844 55.1923 50.3991L52.9939 48.2046C52.7081 47.9193 52.2465 47.9193 51.9607 48.2046L49.7623 50.3991C49.4765 50.6844 49.4765 51.1453 49.7623 51.4306C50.0481 51.7159 50.5097 51.7159 50.7955 51.4306L51.7408 50.4869V54.5761C51.7408 54.9785 52.0706 55.3077 52.4736 55.3077ZM45.6659 48.2046C45.3801 47.9193 44.9185 47.9193 44.6327 48.2046L42.4343 50.3991C42.1485 50.6844 42.1485 51.1453 42.4343 51.4306C42.7201 51.7159 43.1817 51.7159 43.4675 51.4306L44.4128 50.4869V54.5761C44.4128 54.9785 44.7426 55.3077 45.1456 55.3077C45.5487 55.3077 45.8784 54.9785 45.8784 54.5761V50.4869L46.8238 51.4306C46.9703 51.5769 47.1535 51.6427 47.344 51.6427C47.5346 51.6427 47.7178 51.5696 47.8643 51.4306C48.1501 51.1453 48.1501 50.6844 47.8643 50.3991L45.6659 48.2046ZM42.9472 57.5022C42.9472 57.9046 43.277 58.2338 43.68 58.2338H53.9392C54.3423 58.2338 54.672 57.9046 54.672 57.5022C54.672 57.0999 54.3423 56.7707 53.9392 56.7707H43.68C43.277 56.7707 42.9472 57.0999 42.9472 57.5022ZM23.8944 47.9924C22.6853 47.9924 21.696 48.98 21.696 50.187V56.0392C21.696 57.2462 22.6853 58.2338 23.8944 58.2338H32.688C33.8972 58.2338 34.8864 57.2462 34.8864 56.0392V50.187C34.8864 48.98 33.8972 47.9924 32.688 47.9924H23.8944ZM33.4208 50.187V56.0392C33.4208 56.4415 33.0911 56.7707 32.688 56.7707H23.8944C23.4914 56.7707 23.1616 56.4415 23.1616 56.0392V50.187C23.1616 49.7847 23.4914 49.4555 23.8944 49.4555H32.688C33.0911 49.4555 33.4208 49.7847 33.4208 50.187Z'
            fill='#FEFEFE'
          />
          <path
            d='M31.2224 50.9185H25.36C24.957 50.9185 24.6272 51.2477 24.6272 51.6501C24.6272 52.0524 24.957 52.3816 25.36 52.3816H31.2224C31.6254 52.3816 31.9552 52.0524 31.9552 51.6501C31.9552 51.2477 31.6254 50.9185 31.2224 50.9185ZM31.2224 53.8446H25.36C24.957 53.8446 24.6272 54.1738 24.6272 54.5761C24.6272 54.9785 24.957 55.3077 25.36 55.3077H31.2224C31.6254 55.3077 31.9552 54.9785 31.9552 54.5761C31.9552 54.1738 31.6254 53.8446 31.2224 53.8446ZM53.9392 18C49.4911 18 45.8784 21.6064 45.8784 26.0468C45.8784 30.4871 49.4911 34.0935 53.9392 34.0935C58.3873 34.0935 62 30.4871 62 26.0468C62 21.6064 58.3873 18 53.9392 18ZM53.9392 32.6305C50.3045 32.6305 47.344 29.6751 47.344 26.0468C47.344 22.4184 50.3045 19.463 53.9392 19.463C57.5739 19.463 60.5344 22.4184 60.5344 26.0468C60.5344 29.6751 57.5739 32.6305 53.9392 32.6305Z'
            fill='#FEFEFE'
          />
          <path
            d='M57.1998 26.8586L54.6717 25.6003V21.6648C54.6717 21.2624 54.3419 20.9332 53.9389 20.9332C53.5358 20.9332 53.2061 21.2624 53.2061 21.6648V26.0539C53.2061 26.3319 53.3599 26.5879 53.6091 26.7049L56.5403 28.168C56.6429 28.2192 56.7601 28.2485 56.8701 28.2485C57.1412 28.2485 57.3977 28.1022 57.5296 27.8461C57.7128 27.4877 57.5662 27.0488 57.1998 26.8659V26.8586Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_302'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_302'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default AccountingIcon;
